import {Component, Output, EventEmitter, Input, OnInit} from '@angular/core';

@Component({
  selector: 'toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.scss'],
})
export class ToggleSwitchComponent implements OnInit {
  @Input() switchState: boolean = false;
  @Input() isClientMode: boolean = false;

  @Output() toggleState: EventEmitter<boolean> = new EventEmitter();

  @Input() isDisabled: boolean;
  constructor() {}

  ngOnInit() {
    if (this.isClientMode === true) {
      this.switchState = true;
    }
  }
  switchActivated(bool: boolean) {
    this.switchState = !this.switchState;
    this.toggleState.emit(this.switchState);
  }
}
